"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const graphql_1 = require("..");
// export * from './contentSystems';
tslib_1.__exportStar(require("./home"), exports);
tslib_1.__exportStar(require("./osmosysSnap"), exports);
tslib_1.__exportStar(require("./messages"), exports);
tslib_1.__exportStar(require("./ads"), exports);
tslib_1.__exportStar(require("./auth"), exports);
tslib_1.__exportStar(require("./content"), exports);
// export * from './blueprint';
tslib_1.__exportStar(require("./converter"), exports);
tslib_1.__exportStar(require("./core"), exports);
tslib_1.__exportStar(require("./emails"), exports);
tslib_1.__exportStar(require("./flight-manager"), exports);
tslib_1.__exportStar(require("./integrations"), exports);
exports.loadApp = graphql_tag_1.default `
  query loadApp {
    appSettings {
      ...appSettingsDetailData
    }
    currentUser {
      ...currentUserDetailData
    }
  }
  ${graphql_1.appSettingsDetailData}
  ${graphql_1.currentUserDetailData}
`;
//# sourceMappingURL=index.js.map